// Cloudflare Turnstile, loaded only when the public form needs it (the server's requirements say so).

interface TurnstileApi {
  render: (el: HTMLElement, o: { sitekey: string; execution: 'execute'; appearance: 'interaction-only'; language: string; callback: (t: string) => void; 'error-callback': () => void; 'expired-callback': () => void }) => string;
  execute: (id: string) => void;
  reset: (id: string) => void;
  remove: (id: string) => void;
}
declare global {
  interface Window { turnstile?: TurnstileApi }
}

const SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let loading: Promise<TurnstileApi> | null = null;

/** The Turnstile script, added once to the page (a failure lets the next call try again). */
export function loadTurnstile(): Promise<TurnstileApi> {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  loading ??= new Promise<TurnstileApi>((resolve, reject) => {
    const s = document.createElement('script');
    s.src = SRC;
    s.async = true;
    s.onload = () => (window.turnstile ? resolve(window.turnstile) : reject(new Error('turnstile')));
    s.onerror = () => {
      loading = null;
      s.remove();
      reject(new Error('turnstile'));
    };
    document.head.appendChild(s);
  });
  return loading;
}
export type { TurnstileApi };
